import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { LcsResponsiveTableModule } from '@lcs/shared/table';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { DateFilterModule } from 'src/app/common-components/date-filter/date-filter.module';
import { EntitySelectModule } from 'src/app/common-components/entity-select/entity-select.module';
import { LcsSingleSelectModule } from 'src/app/common-components/entity-select/single-select/single-select.module';
import { RegisterModule } from 'src/app/common-components/register/register.module';
import { BannedProvisioningIpRegisterComponent } from './containers/banned-provisioning-ip-register.component';
import { AllowBannedIpDialogComponent } from './dialogs/allow-banned-ip-dialog.component';
import { BannedProvisioningIpRegisterEffects } from './state/banned-provisioning-ip-register.effects';
import {
   bannedProvisioningIpRegisterFeatureKey,
   bannedProvisioningIpRegisterReducer,
} from './state/banned-provisioning-ip-register.reducer';
import { BannedProvisioningIpRegisterView } from './views/banned-provisioning-ip-register-view.component';

@NgModule({
   declarations: [AllowBannedIpDialogComponent, BannedProvisioningIpRegisterComponent, BannedProvisioningIpRegisterView],
   imports: [
      CommonModule,
      FormsModule,
      ReactiveFormsModule,
      DateFilterModule,
      EntitySelectModule,
      LcsResponsiveTableModule,
      RegisterModule,
      MatButtonModule,
      MatDialogModule,
      MatFormFieldModule,
      MatMenuModule,
      MatIconModule,
      MatInputModule,
      MatTooltipModule,
      LcsSingleSelectModule,
      EffectsModule.forFeature([BannedProvisioningIpRegisterEffects]),
      StoreModule.forFeature(bannedProvisioningIpRegisterFeatureKey, bannedProvisioningIpRegisterReducer),
   ],
})
export class BannedProvisioningIpRegisterModule {}
